import React from 'react';
import cx from 'classnames';

import { View } from '@dbk/ui-react-utils';
import { H5 } from '@dbk/ui-text';

import './blur-modal-header.css';

export default function Header({ title, children, className, ...other }) {
  return (
    <View {...other}>
      <View className={cx(className, 'ModalHeader')}>
      <H5 tabIndex={title ? 0 : -1} style={{ color: '#fff' }}>{title}</H5>
        <View className={cx(className, 'HorizontalRule')} />
        {children}
      </View>
    </View>
  );
}
